import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
export function EmotionalClose() {
  return <SectionWrapper className="bg-cream py-20" data-id="element-102">
      <div className="max-w-2xl mx-auto text-center space-y-6 font-sans text-xl text-ink-mid leading-relaxed mb-16 font-medium" data-id="element-103">
        <p data-id="element-104">Esto no te convierte en un padre o madre perfecto.</p>
        <p data-id="element-105">Nada lo hace.</p>
        <p className="font-bold text-ink pt-4" data-id="element-106">
          Pero sí te da algo que la mayoría no tiene:
        </p>
        <p className="text-2xl text-coral font-bold" data-id="element-107">
          Una respuesta preparada para el momento en que más la necesitas.
        </p>
        <p className="pt-4" data-id="element-108">Tu hijo no necesita que nunca te equivoques.</p>
        <p data-id="element-109">Necesita un adulto que aprenda a volver a la calma más rápido.</p>
        <p className="font-bold text-ink" data-id="element-110">Eso eres tú.</p>
        <p data-id="element-111">Y ese es exactamente el punto de partida de este protocolo.</p>
      </div>

      <div className="max-w-2xl mx-auto" data-id="element-112">
        <CTAButton fullWidth data-id="element-113">QUIERO EMPEZAR HOY</CTAButton>
      </div>
    </SectionWrapper>;
}